
import { Component, Vue } from "vue-property-decorator";

@Component
export default class ChangePassword extends Vue {
  currentPassword:any='';
  newPassword:any='';
  confirmPassword:any='';
}
